import React, { useEffect, useState } from 'react'
import { Card } from 'src/Common/ui/card'
import { IoArrowForward } from 'react-icons/io5'
import { Button } from 'src/Common/ui/button'
import { RiRefreshLine } from 'react-icons/ri'
import { Chip } from '@mui/material'
import { useSettingsStore } from 'src/Containers/SettingsContainer/Store/Store'
import { CHIP_VERY_HIGH, CHIP_VERY_LOW } from 'src/Entities/IssueTypes'
import IssueHeatMapDialog from 'src/Containers/IssueRegister/IssueHeatmapDialog'
import HeatMapDialog from 'src/Components/HeatMapDialog'

const TaskMonitoring = ({
    edit,
    formData, setFormData, updatedRiskScore, setUpdatedRiskScore, type = 'RISK'
}) => {
    const [ openHeatMapDialog, setOpenHeatMapDialog ] = useState(false)
    const [ isAssessor, setIsAssessor ] = useState(false)
    const [ heatMapSelection, setheatMapSelection ] = useState(true)
    // const [ riskScore, setRiskScore ] = useState({ impact: null, Probability: null, RiskScore: null })
    const [ initialRiskScore, setInitialRiskScore ] = useState({
        impact: null,
        impactOfRisk: null,
        Probability: null,
        RiskScore: null
    })

    useEffect(() => {
        if (formData?.scoring && !initialRiskScore) {
            setInitialRiskScore({
                impact: formData.scoring.impact,
                impactOfRisk: formData.scoring.impactOfRisk,
                Probability: formData.scoring.probability,
                RiskScore: formData.scoring.riskScore
            })
        }
    }, [formData?.scoring])
    const { configurationData, getConfigurationBasedOrganization } = useSettingsStore()
    const orgId = localStorage.getItem('orgId')
    useEffect(() => {
        getConfigurationBasedOrganization(orgId)
    }, [])
    useEffect(() => {
        if (configurationData?.length > 0) {
            const data = configurationData?.filter(element => element.kindId === 5)
            const heatmap = data?.find(element => element.values === 1)?.subtitleName
            setheatMapSelection(heatmap === '5x5 Heat Map')
        }
    }, [configurationData])

    const chipColorStyle = riskScoreValue => {
        let textColor = 'hsl(var(--foreground))'
        if (riskScoreValue === 'Controlled' || riskScoreValue === CHIP_VERY_LOW) {
            textColor = 'hsl(var(--Controlled))'
        } else if (riskScoreValue === 'Low') {
            textColor = 'hsl(var(--Low))'
        } else if (riskScoreValue === 'Medium') {
            textColor = 'hsl(var(--Medium))'
        } else if (riskScoreValue === 'High') {
            textColor = 'hsl(var(--High))'
        } else if (riskScoreValue === 'Extreme' || riskScoreValue === CHIP_VERY_HIGH) {
            textColor = 'hsl(var(--Extreme))'
        }
        return textColor
    }

    // useEffect(() => {
    //     return () => {
    //         setFormData({ ...formData, })
    //     }
    // })
    const handleClose = () => {
        setOpenHeatMapDialog(false)
    }
    const score = isAssessor ? initialRiskScore : updatedRiskScore
    const setScore = isAssessor ? setInitialRiskScore : setUpdatedRiskScore

    return (
        <React.Fragment>
            <Card className="w-[100%]">
                <div className='taskMonitior'>
                    <p className='text-subHeading-2 text-[hsl(var(--primary))] mb-8 font-bold'>{type === 'RISK' ? 'Assessors Risk Scoring' : 'Assessors Issue Scoring'} :</p>
                    <div className='inline-flex flex-row flex-3'>
                        <div className=' inline-flex pr-1 flex-row items-center'>
                            <p className='text-[hsl(var(--primary))] pr-2 text-subHeading-1 whitespace-nowrap'>Priority :</p>
                            <p className=' text-muted text-subHeading-1' style={{ textDecoration: 'underline' }} onClick={() => { setOpenHeatMapDialog(true); setIsAssessor(true) }}>{formData?.scoring?.impact}</p>
                        </div>
                        <div className=' inline-flex pr-1 flex-row items-center'>
                            <p className='text-[hsl(var(--primary))] pr-2 text-subHeading-1 whitespace-nowrap'>Severity :</p>
                            <p className=' text-muted text-subHeading-1' style={{ textDecoration: 'underline' }} onClick={() => { setOpenHeatMapDialog(true); setIsAssessor(false) }}>{formData?.scoring?.probability}</p>
                        </div>
                        <div className=' inline-flex items-center flex-row'>
                            <p className='text-[hsl(var(--primary))] pr-1   text-subHeading-1 whitespace-nowrap'>{type === 'RISK' ? 'Risk Level :' : 'Issue Level :'}</p>
                            <Chip
                                key={formData?.scoring?.riskScore || ''}
                                label={formData?.scoring?.riskScore || ''}
                                sx={{
                                    width: '100px',
                                    color: 'hsl(var(--foreground))',
                                    backgroundColor: chipColorStyle(formData?.scoring?.riskScore)
                                }}

                            />
                        </div>
                    </div>
                </div>
                <div className='taskMonition-arrow'>
                    <IoArrowForward style={{ width: '25px', fontSize: '5rem', height: '18px', fontWeight: 'bolder', color: 'hsl(var(--primary))' }} />
                </div>
                <div className='taskMonitior'>
                    <div className='inline-flex w-[100%] justify-between'>
                        <p style={{ marginBottom: '2rem' }} className='text-[hsl(var(--primary))] font-bold text-subHeading-2 '>{type === 'RISK' ? 'Current Risk Scoring' : 'Current Issue Scoring'}</p>
                        {edit &&
                        <div>
                            <Button
                                variant='outlined'
                                component='label'
                                size='small'
                                // disabled={tasks[tasks?.length - 1]?.task?.length <= 0}
                                style={{ width: '130px', fontWeight: 'bold', fontSize: '12px', color: 'hsl(var(--primary))', border: '2px solid hsl(var(--primary))' }}
                                onClick={() => { setOpenHeatMapDialog(true); setIsAssessor(false) }}
                            >
                                <span className="flex items-center" style={{ fontWeight: 'bold' }}>
                                    <RiRefreshLine className="mr-2" size={15} /> Update Score
                                </span>
                            </Button>
                        </div>}
                    </div>
                    <div className='inline-flex flex-row flex-3'>
                        <div className='flex pr-1 flex-row items-center'>
                            <p className='text-[hsl(var(--primary))] pr-2 text-subHeading-1 whitespace-nowrap'>Priority :</p>
                            <p className=' text-muted text-subHeading-1' style={{ textDecoration: 'underline' }} onClick={() => setOpenHeatMapDialog(true)}>{updatedRiskScore?.impact}</p>
                        </div>
                        <div className='flex pr-1 flex-row items-center'>
                            <p className='text-[hsl(var(--primary))] pr-2 text-subHeading-1 whitespace-nowrap'>Severity :</p>
                            <p className=' text-muted text-subHeading-1' style={{ textDecoration: 'underline' }} onClick={() => setOpenHeatMapDialog(true)}>{updatedRiskScore?.Probability}</p>
                        </div>
                        <div className='flex flex-row items-center'>
                            <p className='text-[hsl(var(--primary))] pr-1 text-subHeading-1 whitespace-nowrap'>{type === 'RISK' ? 'Risk Level :' : 'Issue Level :'}</p>
                            <Chip
                                key={updatedRiskScore?.RiskScore || ''}
                                label={updatedRiskScore?.RiskScore || ''}
                                sx={{
                                    width: '100px',
                                    color: 'hsl(var(--foreground))',
                                    backgroundColor: chipColorStyle(updatedRiskScore?.RiskScore)
                                }}

                            />
                        </div>
                    </div>
                </div>
            </Card>
            {type === 'RISK'
                ? <HeatMapDialog
                    edit={edit}
                    open={openHeatMapDialog}
                    handleClose={handleClose}
                    heatMapSelection={heatMapSelection}
                    initialRiskScore={score}
                    setinitialRiskScore={setScore}
                    type={'RISK'}
                />
                : <IssueHeatMapDialog
                    edit={edit}
                    open={openHeatMapDialog}
                    handleClose={handleClose}
                    heatMapSelection={heatMapSelection}
                    initialRiskScore={score}
                    setinitialRiskScore={setScore}
                    type={'ISSUE'}
                />}

        </React.Fragment>
    )
}

export default TaskMonitoring
